const REDDIT_WIDGET_SCRIPT = 'https://embed.reddit.com/widgets.js'
const REDDIT_WIDGET_SELECTOR = 'script[data-rio-reddit-widgets]'

let refreshTimer = null

export function refreshRedditEmbeds() {
  if (typeof document === 'undefined') return

  window.clearTimeout(refreshTimer)
  refreshTimer = window.setTimeout(() => {
    if (!document.querySelector('blockquote.reddit-embed-bq')) return

    document.querySelector(REDDIT_WIDGET_SELECTOR)?.remove()

    const script = document.createElement('script')
    script.src = REDDIT_WIDGET_SCRIPT
    script.async = true
    script.charset = 'UTF-8'
    script.dataset.rioRedditWidgets = 'true'
    document.body.appendChild(script)
  }, 40)
}
